import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import * as actions from '../../actions/actions.jsx';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
import '../../stylesheet/coupons.css';
import '../../stylesheet/virtualkeyboard.css';
import LeftLink from '../leftlink/leftlink.jsx';
import Loader from '../loader/loader.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        cardState: state.getCardReducer.cardState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        }
    })
    const JSEncrypt = window.JSEncrypt
class ICoupons extends Component {
    state = {
       
        show: 1,
        value: '',
        loader: true,
        cardDetailsId: "",
        selectedCard: [],
    }
    handleSelect2 = (event, index, value) => {

        const { cardState } = this.props

        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {
                 
                    this.setState({

                        selectedCard: cardState.body[i]
                    })
                }
            }
        });

    }
    handleSelect1 = (event, index, value) => this.setState({ show: value });
    
    componentDidMount() {
        const { publicKey } = this.props
        
        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);

    }

    componentWillReceiveProps(nextProps) {
       
        this.setState({
            loader: true
        })
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    loader: false,
                    cardDetailsId: nextProps.cardState.body[0].cardDetailsId,
                    selectedCard: nextProps.cardState.body[0]
                })
            }
        } catch (e) {

        }

    }

    render() {
        const { cardState } = this.props
        const { cardDetailsId, selectedCard } = this.state
        return (
            <div>
                <div className="row" >
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>
                    <div className="container" style={{ marginTop: "80px" }}>
                        <div className="row">
                            <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                <LeftLink />
                            </div>
                            <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                                <div className="row box-shadow-style" style={{ padding: "12px 0px", minHeight: "476px" }} >
                                    <div className="col-sm-12" style={{marginBottom:"15px"}}>
                                        <div className="header-style">
                                            <h4>
                                                My iCoupons
                                            </h4>
                                            <div style={{marginTop:"15px"}}>
                                                View your accepted iCoupons and accept or decline new iCoupon invitations.
                                            </div>
                                        </div>
                                    </div>
                                    {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?
                                    <div className="col-sm-12" style={{marginTop:"-30px"}}>
                                        <div className="row">
                                            <div className="col-sm-7" style={{marginTop:"35px"}}>

                                                <div className="row">
                                                    <div className="col-sm-2 input-icon" >
                                                        <img style={{marginBottom:"10px"}} src={creditcardlogo} alt="" />
                                                    </div>
                                                    <div className="col-sm-8" >

                                                        <SelectField
                                                            floatingLabelText=""
                                                            onChange={this.handleSelect2}
                                                            className="input-width"
                                                            name="Selected Card"
                                                            style={{ marginTop: -12 }}
                                                            value={cardDetailsId}>
                                                            {cardState.body.map((value, i) =>
                                                                <MenuItem className="menuitem" value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                            )}
                                                        </SelectField>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-5">
                                                <div className="row">
                                                    <div className="col-sm-2 couponsinput" >
                                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-9" >
                                                        <SelectField
                                                            floatingLabelText="Show Me"
                                                            onChange={this.handleSelect1}
                                                            className="input-width"
                                                            name="show"
                                                            value={this.state.show}
                                                        >
                                                            <MenuItem className="menuitem" value={1} primaryText="Invitations" />
                                                            <MenuItem className="menuitem" value={2} primaryText="Accepted" />
                                                            <MenuItem className="menuitem" value={3} primaryText="Declined" />
                                                            <MenuItem className="menuitem" value={4} primaryText="Redeemed" />
                                                            <MenuItem className="menuitem" value={5} primaryText="Partially Redeemed" />
                                                            <MenuItem className="menuitem" value={6} primaryText="Expired" />
                                                            <MenuItem className="menuitem" value={7} primaryText="All" />
                                                        </SelectField>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : <Loader />
                                }
                                    <div className="col-sm-12 text-center">
                                        <div className="coupons">
                                            <h6>No iCoupon(s) Found.</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
ICoupons.defaultProps = {
    cardState: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ICoupons);




// WEBPACK FOOTER //
// ./src/components/additionalservices/icoupons.jsx